import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=322c84c8"
import script from "./product-list.vue?vue&type=script&lang=ts"
export * from "./product-list.vue?vue&type=script&lang=ts"
import style0 from "./product-list.vue?vue&type=style&index=0&id=322c84c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports